import { Box } from '@vimeo/bokeh';
import type { BoxProps } from '@vimeo/bokeh';

export const ResponsiveBox = ({ children, ...props }: BoxProps) => (
  <Box minH={0} overflowY="auto" display="flex" flex={'1 1 auto'} width={'100%'} {...props}>
    {children}
  </Box>
);
